module.exports = __webpack_public_path__ + "static/img/food (1).4333c41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/restaurant/food (1).jpg
// module id = EQzL
// module chunks = 0